import React, { useEffect, useState } from "react";
import websocket from "../services/websocket";

const Symbols = () => {
  const [symbols, setSymbols] = useState([]);

  useEffect(() => {
    websocket.connect();

    const unsubscribe = websocket.onTick((data) => {
      if (data.active_symbols) {
        const forexSymbols = data.active_symbols
          .filter((item) => item.market === "forex")
          .sort((a, b) => a.display_name.localeCompare(b.display_name));

        setSymbols(forexSymbols);
      }
    });

    websocket.activeSymbols();

    return () => {
      unsubscribe();
      websocket.close();
    };
  }, []);

  return (
    <div style={{ padding: 20 }}>
      <h2>Deriv Forex Symbols</h2>

      {symbols.map((item) => (
        <div
          key={item.symbol}
          style={{
            padding: "10px",
            marginBottom: "8px",
            border: "1px solid #ddd",
            borderRadius: "8px",
          }}
        >
          <strong>{item.display_name}</strong>
          <br />
          <small>{item.symbol}</small>
        </div>
      ))}
    </div>
  );
};

export default Symbols;